export async function copyToClipboard(value) {
  // Use Clipboard API if available
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      toast.success("Link Copied to Clipboard!");
    } catch (err) {
      // console.warn("Clipboard API failed, falling back to execCommand:", err);
      deprecatedCopyToClipboard(value);
    }
  } else {
    deprecatedCopyToClipboard(value);
  }
}

function deprecatedCopyToClipboard(value) {
  const textArea = document.createElement("textarea");

  textArea.value = value;
  document.body.appendChild(textArea);
  textArea.select();
  
  try {
    const successful = document.execCommand("copy");
    if (!successful) {
      // console.warn("Copy command was unsuccessful.");
    } else {
      toast.success("Link Copied to Clipboard!");
    }
  } catch (err) {
    // console.error("Failed to copy text:", err);
    toast.warning("Failed to copy text to clipboard.");
  }

  document.body.removeChild(textArea);
}